module.exports = __webpack_public_path__ + "static/media/mail-sent.3ad569e1.svg";